/*
  Plainpad - Self Hosted Note Taking App

  Copyright (C) Alex Tselegidis - https://alextselegidis.com

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>
*/

export default {
  user: 'Utilisateur',
  users: 'Utilisateurs',
  name: 'Nom',
  email: 'E-mail',
  password: 'Mot de passe',
  passwordConfirmation: 'Confirmation mot de passe',
  admin: 'Administrateur',
  role: 'Rôle',
  actions: 'Actions',
  add: 'Ajouter',
  edit: 'Éditer',
  save: 'Sauver',
  saveSuccess: 'Utilisateur enregistré avec succès.',
  saveFailure: 'L\'utilisateur n\'a pas pu être enregistré.',
  delete: 'Supprimer',
  deletePrompt: 'Voulez-vous vraiment supprimer cet utilisateur ?',
  deleteSuccess: 'Utilisateur supprimé avec succès.',
  deleteFailure: 'L\'utilisateur n\'a pas pu être supprimé.',
  cancel: 'Annuler',
  search: 'Chercher',
  emailAlreadyInUse: 'L\'adresse e-mail est déjà utilisée, veuillez en utiliser une autre.',
  passwordsMismatch: 'Les mots de passe ne correspondent pas, veuillez réessayer.',
  nameRequired: 'Le nom est obligatoire, veuillez saisir une valeur.',
  emailRequired: 'L\'e-mail est obligatoire, veuillez saisir une valeur.',
  emailInvalid: 'L\'adresse e-mail est invalide, veuillez saisir une adresse valide.',
  passwordRequired: 'Le mot de passe est obligatoire pour les nouveaux utilisateurs, veuillez saisir une valeur.',
  listFailure: 'Les utilisateurs n\'ont pas pu être répertoriés, veuillez réessayer.',
  filterUsers: 'Filtrer les utilisateurs',
}
